import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue";
import _imports_0 from '@/assets/icons/kizuna-logo.svg';
const _hoisted_1 = {
  class: "genesis-section luxy-el",
  "data-speed-y": "-75"
};
const _hoisted_2 = {
  class: "panel"
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "stars-background"
}, null, -1);
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "top-left corner-decoration"
}, null, -1);
const _hoisted_5 = {
  class: "content-container"
};
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"texts-container\"><div class=\"title-container\"><img class=\"logo\" src=\"" + _imports_0 + "\" alt=\"KIZUNA\"><p class=\"title\">GENESIS</p></div><p class=\"text kizuna\"> KIZUNA GENESIS is a premium collection of 7777 anime-style avatars, featuring an unparalleled count of over 1200 meticulously hand-drawn traits. </p><p class=\"text algorithm\"> By applying a custom generation algorithm that incorporates color and trait matching logic to such a large number of traits, KIZUNA GENESIS pushes the boundaries of aesthetics and diversity in the generative NFT space. </p></div>", 1);
const _hoisted_7 = {
  class: "avatar-container"
};
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinning-circle hidden-xs-only"
}, null, -1);
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "star"
}, null, -1);
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  class: "big-circle"
}, null, -1);
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", {
  class: "small-circle"
}, null, -1);
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"description-container hidden-xs-only traits\"><div class=\"description\"><p class=\"title\">TRAITS</p><p class=\"value\">1200+</p></div><div class=\"shadow\"></div></div><div class=\"description-container hidden-xs-only supply\"><div class=\"description\"><p class=\"title\">SUPPLY</p><p class=\"value\">7777</p></div><div class=\"shadow\"></div></div><div class=\"description-container hidden-xs-only license\"><div class=\"description\"><p class=\"title\">LICENSE</p><p class=\"value\">CC0</p></div><div class=\"shadow\"></div></div><div class=\"description-container hidden-xs-only storage\"><div class=\"description\"><p class=\"title\">STORAGE</p><p class=\"value\">arweave</p></div><div class=\"shadow\"></div></div><div class=\"description-container hidden-xs-only chain\"><div class=\"description\"><p class=\"title\">CHAIN</p><p class=\"value\">ethereum</p></div><div class=\"shadow\"></div></div>", 5);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _hoisted_4, _createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, [_hoisted_8, _hoisted_9, _hoisted_10, _hoisted_11, (_openBlock(), _createElementBlock(_Fragment, null, _renderList(21, index => {
    return _createElementVNode("div", {
      class: _normalizeClass(["avatar", {
        visible: _ctx.displayedIndex === index,
        [`a${index}`]: true
      }]),
      key: `avatar-${index}`
    }, null, 2);
  }), 64)), _hoisted_12])])])]);
}